<html lang="en">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">

  <meta http-equiv="x-ua-compatible" content="ie=edge">
  <meta name="author" content="Xmartlabs">

</head>

<body id="terms-and-conditions">
  <div class="container-fluid">
    <div class="row terms-and-conditions-section">
  
      <div class="col-xs-12 hed" style="background-image:linear-gradient(rgb(30, 148, 250), rgb(45, 222, 255));height: 250px;" >
       
      </div>
      <div class="col-lg-4"></div>
      <div class="col-lg-4 text-center sh-page" >
        <img src="assets/img/FCH.png" alt="FCH" style="margin-bottom: 20px;">
        <h4>Family Care Hospital</h4>
        <p>من خلال تحميلك لتطبيق المستشفى نقدم لك تجربة رائعة للاستفادة من كافة الخدمات عن بعد باللغتين العربية والإنجليزية</p>
            <a target="AppStore" [href]="environment.IOSAppLink">
                <img src="assets/img/contact/AppStore.png" alt="AppStore" height="75px" width="210px" >
            </a><br>
            <a target="Android" [href]="environment.AndroidAppLink">
                <img src="assets/img/contact/Android.png" alt="Android" height="80px" width="220px" >
            </a>
      </div>
      <div class="col-lg-4"></div>
      <div class="col-lg-4"></div>
      <div class="col-lg-4 fot text-center" style="margin: 20px 0px">
        <a class="sh-page__website ng-binding" href="http://www.familycare.com.sa/" target="_blank" ng-style="{color: getTextColor2()}" style="color: rgb(51, 51, 51);">
            www.familycare.com.sa
        </a>
        <p>Developed By <a href="http://4utechnology.org/" target="_blank" style="text-decoration: underline !important;">4utechnology</a></p>

      </div>
    
    </div>
  </div>
</body>
</html>